import { render } from "./P044.vue?vue&type=template&id=09ff8f10&scoped=true"
import script from "./P044.vue?vue&type=script&lang=js"
export * from "./P044.vue?vue&type=script&lang=js"

import "./P044.vue?vue&type=style&index=0&id=09ff8f10&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ff8f10"]])

export default __exports__